import type { FC } from 'react'
import styled from '@emotion/styled'

import { css } from '@emotion/react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import Badge from '@segment/matcha/components/Badge'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Learn from very best across every industry`,
  description: `We distilled the best tips, tricks & trends from our guests for you. Learn how to power your customer engagement strategies with a strong data foundation.`,
}

const cardData = [
  {
    href: `https://learn.segment.com/customer-engagement-tactics/`,
    badge: `Guide`,
    title: `How Top Brands from IBM to PepsiCo Use Data to Strengthen Customer Relationships`,
    description: `To provide memorable experiences, businesses must use proven tactics to engage customers. Learn how top brands are focusing on customer engagement to build stronger relationships.`,
    action: `Read the guide`,
  },
  {
    href: `/learn/download/ai-powered-personalization/`,
    badge: `Ebook`,
    title: `Personalization in the Age of AI: How 4 Brands are Shaping the Future`,
    description: `Learn how AI-powered personalization is reshaping the customer experience, and how four leading brands (Instacart, Nextdoor, Saks, and Amazon) are using it to improve customer engagement and drive growth.`,
    action: `Read the ebook`,
  },
]

const LearnFromVeryBest: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack
          aria-live="polite"
          columns={1}
          overrides={{
            md: 2,
            xl: cardData.length,
          }}
          center={true}
          length={cardData.length}
        >
          {cardData &&
            cardData.map((data) => (
              <CardBase href={getAbsoluteUrl(data.href, pageConfig)} layout="vertical" key={data.title}>
                <Card.Body>
                  <Card.Accessories>
                    <Card.AccessoriesRow>
                      <Badge variant="outlined">{data.badge}</Badge>
                    </Card.AccessoriesRow>
                  </Card.Accessories>
                  <Card.Copy>
                    <Card.Headline tag="h3">{data.title}</Card.Headline>
                    <Card.Description variant="pLarge">{data.description}</Card.Description>
                  </Card.Copy>
                  <Card.Action alignment="left">
                    <ButtonText iconEnd={ChevronRightIcon}>{data.action}</ButtonText>
                  </Card.Action>
                </Card.Body>
              </CardBase>
            ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

interface ColumnTrackProps {
  length: number
}
const StyledColumnTrack = styled(ColumnTrack)<ColumnTrackProps>`

${({ theme }) => theme.breakpoints.up(`lg`)} {
    ${({ length }) =>
      length <= 2 &&
      css`
        max-width: 896px;
        margin: 0 auto;
      `}
`

export default LearnFromVeryBest
